/**
 * @file home页
 * @author fengfaxia(fengfaxia@baidu.com))
 *  Copyright (c) 2018-08-17 Baidu
 */

import React from 'react';
import './index.less';

export default class Feedback extends React.Component {
    state = {
        feedbackTipDisplay: 'none',
        feedbackIconDisplay: 'block'
    }
    // feedbackEnter() {
    //     this.setState({
    //         feedbackIconDisplay: 'none',
    //         feedbackTipDisplay: 'block'
    //     });
    // }
    // feedbackLeave() {
    //     this.setState({
    //         feedbackIconDisplay: 'block',
    //         feedbackTipDisplay: 'none'
    //     });
    // }
    render() {
        return (
            <div></div>
        );
    }
}
